import { IconProject, IconEye, IconCameraPlay, IconMasks, IconTime, IconTag } from 'assets'
import { ViewerTabTableColumn, TableCell } from 'components/viewers/ViewerTabTable/types'

export enum TotalWatchColEnums {
  PROJECT = 'Project',
  WATCH_TIME = 'Watch',
  PROJECT_TYPE = 'Type',
  GENRE = 'Genre',
  ADDED_AT = 'Added At',
  TAGS = 'Tag'
}

export const totalWatchColumns: {
  [key in TotalWatchColEnums]: ViewerTabTableColumn<TotalWatchColEnums>
} = {
  [TotalWatchColEnums.PROJECT]: {
    label: TotalWatchColEnums.PROJECT,
    icon: IconProject,
    sortable: false,
    width: '20%'
  },
  [TotalWatchColEnums.WATCH_TIME]: {
    icon: IconEye,
    label: TotalWatchColEnums.WATCH_TIME,
    sortable: true,
    width: '10%'
  },
  [TotalWatchColEnums.PROJECT_TYPE]: {
    icon: IconCameraPlay,
    label: TotalWatchColEnums.PROJECT_TYPE,
    sortable: false,
    width: '10%'
  },
  [TotalWatchColEnums.GENRE]: {
    icon: IconMasks,
    label: TotalWatchColEnums.GENRE,
    sortable: false,
    width: '20%'
  },
  [TotalWatchColEnums.ADDED_AT]: {
    icon: IconTime,
    label: TotalWatchColEnums.ADDED_AT,
    sortable: false,
    width: '10%'
  },
  [TotalWatchColEnums.TAGS]: {
    icon: IconTag,
    label: TotalWatchColEnums.TAGS,
    sortable: false,
    width: '30%'
  }
}

export type TotalWatchLineInfo = { [key in TotalWatchColEnums]: TableCell }
